const timeStringToSeconds = (hms?: string): number => {
  if (hms === undefined) {
    return 0;
  }
  const [hours, minutes, seconds] = hms.split(':').map((timeChunk) => (Number(timeChunk) ? parseInt(timeChunk) : 0));
  return hours * 60 * 60 + minutes * 60 + seconds;
};

export default timeStringToSeconds;
